import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import { useList } from "modules/oked/hooks";
import { useStatsList } from "modules/mandatoryRequirement/hooks";
import { MANDATORY_CATEGORY_TYPE } from "modules/mandatoryRequirement/constants";

import * as Grid from "components/Grid";

import StatCard from "components/Card";
import Spacer from "components/Spacer";
import Button from "components/Button";
import Container from "components/Container";
import OkedCard from "pages/Oked/components/OkedCard";

import cls from "./MandatoryRequirementRegister.module.scss";
import { LoadingOutlined } from "@ant-design/icons";

const MandatoryRequirementRegister = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [type, setType] = useState(MANDATORY_CATEGORY_TYPE.OKED);

  const { items: okedItems, isFetched: isOkedFetched } = useList({
    enabled: type === MANDATORY_CATEGORY_TYPE.OKED,
    params: {
      perPage: 8,
    }
  });

  const { items: statItems, isFetched: isStatsFetched } = useStatsList({
    enabled: type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS,
    params: {
      perPage: 8,
    }
  });

  return (
    <section className={cls.section}>
      <Container>
        <div className={cls.tabs}>
          {Object.values(MANDATORY_CATEGORY_TYPE).map(item => (
            <div
              className={cx(cls.tab, type === item && cls.tabActive)}
              onClick={() => setType(item)}
              key={item}
            >
              {t(`mandatory_${item}`)}
            </div>
          ))}
        </div>

        <Spacer size={50} />

        <Grid.Row gutter={[16, 16]}>
          {type === MANDATORY_CATEGORY_TYPE.OKED && okedItems
            .map(item => (
              <Grid.Col span={6} key={item.id}>
                <OkedCard
                  id={item.id}
                  name={item.name[i18n.language]}
                  count={item.requirements_count}
                  section={item.code}
                // onClick={() => navigate(`/mandatory-requirement/register?mandatory_id=${item.id}`)}
                />
              </Grid.Col>
            ))}

          {type === MANDATORY_CATEGORY_TYPE.OKED && !isOkedFetched && (
            <div className={cls.loading}>
              <LoadingOutlined />
            </div>
          )}
        </Grid.Row>

        {okedItems.length > 0 && type === MANDATORY_CATEGORY_TYPE.OKED && (
          <div className={cls.btn}>
            <Button onClick={() => navigate('/oked')}>
              {t('action_more')}
            </Button>
          </div>
        )}

        <Grid.Row gutter={[16, 16]}>
          {type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && statItems
            .map(item => (
              <Grid.Col span={6} key={item.id}>
                <StatCard
                  id={item.id}
                  name={item.name[i18n.language]}
                  uuid={item.file_response.uuid}
                  count={item.register_requirements_count}
                  onClick={() => navigate(`/mandatory-requirement?organizationId=${item.id}`)}
                />
              </Grid.Col>
            ))}

          {type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && !isStatsFetched && (
            <div className={cls.loading}>
              <LoadingOutlined />
            </div>
          )}
        </Grid.Row>

        {statItems.length > 0 && type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && (
          <div className={cls.btn}>
            <Button onClick={() => navigate('/organization-stats')}>
              {t('action_more')}
            </Button>
          </div>
        )}
      </Container>
    </section>
  )
}

export default MandatoryRequirementRegister;